export { default as SearchBar } from './component';
